import { AxiosError, AxiosResponse } from 'axios';

import AuthService from '../../shared/services/AuthService';
import { Collection } from '../models/ResourceModel/Collection';
import Config from '../../shared/config';
import useSWR from 'swr';

const noLearnerCollections: Collection[] = [];

export const useLearnerCollections = () => {
  const userkey = AuthService.Userkey;
  //API endpoints to list collection for a user/learner
  const listLearnerCollectionUrl = `${Config.API}/api/resource/list/collection/user/${userkey}`;

  //List learner collections
  const {
    data: learnersCollectionsData,
    error: learnerCollectionsError,
    isValidating: learnerCollectionsLoading
  } = useSWR<AxiosResponse<Collection[]>, AxiosError<Error>>(
    listLearnerCollectionUrl
  );

  return {
    learnerCollectionsLoading,
    learnerCollectionsError,
    learnerCollections: learnersCollectionsData?.data || noLearnerCollections
  };
};
